// eslint-disable-next-line import/no-cycle
import { ArtikelEigenschaft } from 'api/artikelEigenschaft';
// eslint-disable-next-line import/no-cycle
import { Textbaustein } from 'api/textbaustein';
// eslint-disable-next-line import/no-cycle
import {
    defaultLookups,
    Lookups,
    LookupsAction,
    LookupsActionType,
    TextbausteineActionPayload,
    BetreuerActionPayload,
    ArtikelGruppenActionPayload,
    BranchenActionPayload,
    InteresseFuerProdukteActionPayload,
    ErweiterteSuchenActionPayload,
    LaenderActionPayload,
    SkontodefinitionenActionPayload,
    EinheitenActionPayload,
    LagerActionPayload,
    AraRegelungenActionPayload,
    LieferantenformulareActionPayload,
    KalkulationsblaetterActionPayload,
    ArtikelEigenschaftenActionPayload,
    ProduktgruppenActionPayload,
    ProduzentenActionPayload,
    KontodefinitionenActionPayload,
    MaschinentypenActionPayload,
} from './types';

export function lookupsReducer(state: Lookups = defaultLookups, action: LookupsAction): Lookups {
    switch (action.type) {
        case LookupsActionType.REQUEST_BETREUER:
            return {
                ...state,
                betreuerLoaded: false,
            };

        case LookupsActionType.RECEIVE_BETREUER:
            if (action.payload?.success) {
                const betreuer = (action.payload as BetreuerActionPayload)?.betreuer || [];
                return {
                    ...state,
                    betreuer,
                    betreuerByNr: betreuer.reduce((acc, betreuer2) => ({ ...acc, [betreuer2.nr]: betreuer2 }), {}),
                    betreuerByKz: betreuer.reduce((acc, betreuer2) => ({ ...acc, [betreuer2.kz]: betreuer2 }), {}),
                    betreuerLoaded: true,
                };
            }

            return {
                ...state,
                betreuerLoaded: false,
            };

        case LookupsActionType.REQUEST_TEXTBAUSTEINE:
            return {
                ...state,
                textbausteineLoaded: false,
            };

        case LookupsActionType.RECEIVE_TEXTBAUSTEINE:
            if (action.payload?.success) {
                const textbausteine =
                    (action.payload as TextbausteineActionPayload)?.textbausteine || state.textbausteine;

                const textbausteineByKz: { [key: number]: Textbaustein[] } = {};

                textbausteine?.forEach((textbaustein) => {
                    if (!textbausteineByKz[textbaustein.kz]) {
                        textbausteineByKz[textbaustein.kz] = [];
                    }

                    textbausteineByKz[textbaustein.kz].push(textbaustein);
                });

                const textbausteineByKzNr: { [key: number]: { [key: number]: Textbaustein } } = {};

                textbausteine?.forEach((textbaustein) => {
                    if (!textbausteineByKzNr[textbaustein.kz]) {
                        textbausteineByKzNr[textbaustein.kz] = {};
                    }

                    textbausteineByKzNr[textbaustein.kz][textbaustein.nr] = textbaustein;
                });

                return {
                    ...state,
                    textbausteine,
                    textbausteineByKz,
                    textbausteineByKzNr,
                    textbausteineLoaded: true,
                };
            }

            return {
                ...state,
                textbausteineLoaded: false,
            };

        case LookupsActionType.REQUEST_ARTIKELGRUPPEN:
            return {
                ...state,
                artikelGruppenLoaded: false,
            };

        case LookupsActionType.RECEIVE_ARTIKELGRUPPEN:
            if (action.payload?.success) {
                const artikelGruppen =
                    (action.payload as ArtikelGruppenActionPayload)?.artikelGruppen || state.artikelGruppen;
                return {
                    ...state,
                    artikelGruppen,
                    artikelGruppenByNr: artikelGruppen.reduce(
                        (acc, artikelGruppe) => ({ ...acc, [artikelGruppe.nr]: artikelGruppe }),
                        {},
                    ),
                    artikelGruppenLoaded: true,
                };
            }

            return {
                ...state,
                artikelGruppenLoaded: false,
            };

        case LookupsActionType.REQUEST_BRANCHEN:
            return {
                ...state,
                branchenLoaded: false,
            };

        case LookupsActionType.RECEIVE_BRANCHEN:
            if (action.payload?.success) {
                const branchen = (action.payload as BranchenActionPayload)?.branchen || state.branchen;
                return {
                    ...state,
                    branchen,
                    branchenByNr: branchen.reduce((acc, branche) => ({ ...acc, [branche.nr]: branche }), {}),
                    branchenLoaded: true,
                };
            }

            return {
                ...state,
                branchenLoaded: false,
            };

        case LookupsActionType.REQUEST_INTERESSEFUERPRODUKTE:
            return {
                ...state,
                interesseFuerProdukteLoaded: false,
            };

        case LookupsActionType.RECEIVE_INTERESSEFUERPRODUKTE:
            if (action.payload?.success) {
                const interesseFuerProdukte =
                    (action.payload as InteresseFuerProdukteActionPayload)?.interesseFuerProdukte ||
                    state.interesseFuerProdukte;
                return {
                    ...state,
                    interesseFuerProdukte,
                    interesseFuerProdukteByNr: interesseFuerProdukte.reduce(
                        (acc, interesseFuerProdukte2) => ({
                            ...acc,
                            [interesseFuerProdukte2.nr]: interesseFuerProdukte2,
                        }),
                        {},
                    ),
                    interesseFuerProdukteLoaded: true,
                };
            }

            return {
                ...state,
                interesseFuerProdukteLoaded: false,
            };

        case LookupsActionType.REQUEST_ERWEITERTESUCHEN:
            return {
                ...state,
                erweiterteSuchenLoaded: false,
            };

        case LookupsActionType.RECEIVE_ERWEITERTESUCHEN:
            if (action.payload?.success) {
                const erweiterteSuchen =
                    (action.payload as ErweiterteSuchenActionPayload)?.erweiterteSuchen || state.erweiterteSuchen;
                return {
                    ...state,
                    erweiterteSuchen,
                    erweiterteSuchenByNr: erweiterteSuchen.reduce(
                        (acc, erweiterteSuche) => ({ ...acc, [erweiterteSuche.nr]: erweiterteSuche }),
                        {},
                    ),
                    erweiterteSuchenLoaded: true,
                };
            }

            return {
                ...state,
                erweiterteSuchenLoaded: false,
            };

        case LookupsActionType.REQUEST_LAENDER:
            return {
                ...state,
                laenderLoaded: false,
            };

        case LookupsActionType.RECEIVE_LAENDER:
            if (action.payload?.success) {
                const laender = (action.payload as LaenderActionPayload)?.laender || state.laender;
                return {
                    ...state,
                    laender,
                    laenderByIkz2: laender.reduce((acc, land) => ({ ...acc, [land.ikz2]: land }), {}),
                    laenderLoaded: true,
                };
            }

            return {
                ...state,
                laenderLoaded: false,
            };

        case LookupsActionType.REQUEST_SKONTODEFINITIONEN:
            return {
                ...state,
                skontodefinitionenLoaded: false,
            };

        case LookupsActionType.RECEIVE_SKONTODEFINITIONEN:
            if (action.payload?.success) {
                const skontodefinitionen =
                    (action.payload as SkontodefinitionenActionPayload)?.skontodefinitionen || state.skontodefinitionen;
                return {
                    ...state,
                    skontodefinitionen,
                    skontodefinitionenByArt: skontodefinitionen.reduce(
                        (acc, skontodefinition) => ({ ...acc, [skontodefinition.art]: skontodefinition }),
                        {},
                    ),
                    skontodefinitionenLoaded: true,
                };
            }

            return {
                ...state,
                skontodefinitionenLoaded: false,
            };

        case LookupsActionType.REQUEST_KONTODEFINITIONEN:
            return {
                ...state,
                kontodefinitionenLoaded: false,
            };

        case LookupsActionType.RECEIVE_KONTODEFINITIONEN:
            if (action.payload?.success) {
                const kontodefinitionen =
                    (action.payload as KontodefinitionenActionPayload)?.kontodefinitionen || state.kontodefinitionen;
                return {
                    ...state,
                    kontodefinitionen,
                    kontodefinitionenLoaded: true,
                };
            }

            return {
                ...state,
                kontodefinitionenLoaded: false,
            };

        case LookupsActionType.REQUEST_EINHEITEN:
            return {
                ...state,
                einheitenLoaded: false,
            };

        case LookupsActionType.RECEIVE_EINHEITEN:
            if (action.payload?.success) {
                const einheiten = (action.payload as EinheitenActionPayload)?.einheiten || state.einheiten;
                return {
                    ...state,
                    einheiten,
                    einheitenByCode: einheiten.reduce((acc, einheit) => ({ ...acc, [einheit.code]: einheit }), {}),
                    einheitenLoaded: true,
                };
            }

            return {
                ...state,
                einheitenLoaded: false,
            };

        case LookupsActionType.REQUEST_LAGER:
            return {
                ...state,
                lagerLoaded: false,
            };

        case LookupsActionType.RECEIVE_LAGER:
            if (action.payload?.success) {
                const lager = (action.payload as LagerActionPayload)?.lager || state.lager;
                return {
                    ...state,
                    lager,
                    lagerByIntNr: lager.reduce((acc, l) => ({ ...acc, [l.intNr]: l }), {}),
                    lagerLoaded: true,
                };
            }

            return {
                ...state,
                lagerLoaded: false,
            };

        case LookupsActionType.REQUEST_ARA_REGELUNGEN:
            return {
                ...state,
                araRegelungenLoaded: false,
            };

        case LookupsActionType.RECEIVE_ARA_REGELUNGEN:
            if (action.payload?.success) {
                const araRegelungen =
                    (action.payload as AraRegelungenActionPayload)?.araRegelungen || state.araRegelungen;
                return {
                    ...state,
                    araRegelungen,
                    araRegelungenByArt: araRegelungen.reduce((acc, ara) => ({ ...acc, [ara.art]: ara }), {}),
                    araRegelungenLoaded: true,
                };
            }

            return {
                ...state,
                araRegelungenLoaded: false,
            };

        case LookupsActionType.REQUEST_LIEFERANTENFORMULARE:
            return {
                ...state,
                lieferantenformulareLoaded: false,
            };

        case LookupsActionType.RECEIVE_LIEFERANTENFORMULARE:
            if (action.payload?.success) {
                const lieferantenformulare =
                    (action.payload as LieferantenformulareActionPayload)?.lieferantenformulare ||
                    state.lieferantenformulare;
                return {
                    ...state,
                    lieferantenformulare,
                    lieferantenformulareByNr: lieferantenformulare.reduce((acc, lf) => ({ ...acc, [lf.nr]: lf }), {}),
                    lieferantenformulareLoaded: true,
                };
            }

            return {
                ...state,
                lieferantenformulareLoaded: false,
            };

        case LookupsActionType.REQUEST_KALKULATIONSBLAETTER:
            return {
                ...state,
                kalkulationsblaetterLoaded: false,
            };

        case LookupsActionType.RECEIVE_KALKULATIONSBLAETTER:
            if (action.payload?.success) {
                const kalkulationsblaetter =
                    (action.payload as KalkulationsblaetterActionPayload)?.kalkulationsblaetter ||
                    state.kalkulationsblaetter;
                return {
                    ...state,
                    kalkulationsblaetter,
                    kalkulationsblaetterByBlatt: kalkulationsblaetter.reduce(
                        (acc, kb) => ({ ...acc, [kb.blatt]: kb }),
                        {},
                    ),
                    kalkulationsblaetterLoaded: true,
                };
            }

            return {
                ...state,
                kalkulationsblaetterLoaded: false,
            };

        case LookupsActionType.REQUEST_ARTIKELEIGENSCHAFTEN:
            return {
                ...state,
                artikelEigenschaftenLoaded: false,
            };

        case LookupsActionType.RECEIVE_ARTIKELEIGENSCHAFTEN:
            if (action.payload?.success) {
                const artikelEigenschaften =
                    (action.payload as ArtikelEigenschaftenActionPayload)?.artikelEigenschaften ||
                    state.artikelEigenschaften;

                const artikelEigenschaftenByKzNr: { [key: string]: { [key: number]: ArtikelEigenschaft } } = {};

                artikelEigenschaften?.forEach((artikelEigenschaft) => {
                    if (!artikelEigenschaftenByKzNr[artikelEigenschaft.eigenschaftKz]) {
                        artikelEigenschaftenByKzNr[artikelEigenschaft.eigenschaftKz] = {};
                    }

                    artikelEigenschaftenByKzNr[artikelEigenschaft.eigenschaftKz][
                        artikelEigenschaft.eigenschaftNr
                    ] = artikelEigenschaft;
                });

                return {
                    ...state,
                    artikelEigenschaften,
                    artikelEigenschaftenByKzNr,
                    artikelEigenschaftenLoaded: true,
                };
            }

            return {
                ...state,
                artikelEigenschaftenLoaded: false,
            };

        case LookupsActionType.REQUEST_PRODUKTGRUPPEN:
            return {
                ...state,
                produktgruppenLoaded: false,
            };

        case LookupsActionType.RECEIVE_PRODUKTGRUPPEN:
            if (action.payload?.success) {
                const produktgruppen =
                    (action.payload as ProduktgruppenActionPayload)?.produktgruppen || state.produktgruppen;
                return {
                    ...state,
                    produktgruppen,
                    produktgruppenByNr: produktgruppen.reduce((acc, pg) => ({ ...acc, [pg.nr]: pg }), {}),
                    produktgruppenLoaded: true,
                };
            }

            return {
                ...state,
                produktgruppenLoaded: false,
            };

        case LookupsActionType.REQUEST_PRODUZENTEN:
            return {
                ...state,
                produzentenLoaded: false,
            };

        case LookupsActionType.RECEIVE_PRODUZENTEN:
            if (action.payload?.success) {
                const produzenten = (action.payload as ProduzentenActionPayload)?.produzenten || state.produzenten;
                return {
                    ...state,
                    produzenten,
                    produzentenByNr: produzenten.reduce((acc, pr) => ({ ...acc, [pr.nr]: pr }), {}),
                    produzentenLoaded: true,
                };
            }

            return {
                ...state,
                produzentenLoaded: false,
            };

        case LookupsActionType.REQUEST_MASCHINENTYPEN:
            return {
                ...state,
                maschinentypenLoaded: false,
            };

        case LookupsActionType.RECEIVE_MASCHINENTYPEN:
            if (action.payload?.success) {
                const maschinentypen =
                    (action.payload as MaschinentypenActionPayload)?.maschinentypen || state.maschinentypen;
                return {
                    ...state,
                    maschinentypen,
                    maschinentypenByNr: maschinentypen.reduce((acc, mt) => ({ ...acc, [mt.nr]: mt }), {}),
                    maschinentypenLoaded: true,
                };
            }

            return {
                ...state,
                maschinentypenLoaded: false,
            };

        case LookupsActionType.FINISH_LOADING:
            return {
                ...state,
                loadingFinished: true,
            };

        default:
            return state;
    }
}
